export class Notification {
  constructor(obj) {
    this.id = obj.id;
    this.is_seen = obj.is_seen;
    this.type = obj.type;
    this.created_at = new Date(obj.created_at);
    this.updated_at = new Date(obj.updated_at);
  }
}
